module.exports = {"audiences":["newUsers","allMembers"],"autoTrack":true,"experimentAllocation":{"allMembers":0,"newUsers":1},"defaultWeight":1,"experimentVersion":"v2","defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-01-23"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/expandedCardBack.json
// module id = sxY6
// module chunks = 2